export function validatePortuguesePhoneNumber(phoneNumber: string) {
  if (phoneNumber.length < 3) {
    return false;
  }

  if (
    phoneNumber.slice(0, 4) !== "+351" ||
    (phoneNumber.length === 13 && Array.from(phoneNumber)[4] === "9")
  ) {
    return true;
  }
  return false;
}
